import React from 'react';
import { TFunction, withTranslation } from 'react-i18next';
import '@chewy/kib-chips-styles/dist/styles/kib-chip-tab.css';
import Banner from './Banner';
import Logo from './Logo';
import './header.scss';

export const Header = ({ t }: { t: TFunction<string> }) => (
  <div className="starter-guide-header" data-testid="starter-guide-header">
    <Banner />
    <div className="starter-guide-header__content">
      <Logo isMainLogo={true} title={t('puppyGuide.logo')} />
      <h2 className="starter-guide-header__title">{t('puppyGuide.title')}</h2>
    </div>
  </div>
);

export default withTranslation()(Header);
